import React from 'react';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@dashboard/components/ui/select';

import { AI_USAGE_PERIOD_LABELS, AI_USAGE_PERIODS, type AiUsagePeriod } from './aiUsagePeriod';

type Props = { value: AiUsagePeriod; onValueChange: (period: AiUsagePeriod) => void };

const AiUsagePeriodSelect = ({ value, onValueChange }: Props) => (
  <Select value={value} onValueChange={next => onValueChange(next as AiUsagePeriod)}>
    <SelectTrigger aria-label="Period" className="!w-40">
      <SelectValue />
    </SelectTrigger>
    <SelectContent>
      {AI_USAGE_PERIODS.map(period => (
        <SelectItem key={period} value={period}>
          {AI_USAGE_PERIOD_LABELS[period]}
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
);

export default AiUsagePeriodSelect;
